import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";

import Colors from "../theme/Colors";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "70vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: { xs: "1.5rem", md: "3rem" },
        gap: "1rem",
      }}
    >
      {/* Icono en chip de fondo suave (design.md §2.4) */}
      <Box
        sx={{
          background: Colors.AzulMediline10,
          color: Colors.AzulMediline,
          width: "88px",
          height: "88px",
          borderRadius: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "& svg": { fontSize: "48px" },
        }}
      >
        <SentimentDissatisfiedIcon />
      </Box>

      <Typography
        sx={{
          fontSize: { xs: "3rem", md: "4.5rem" },
          fontWeight: 800,
          lineHeight: 1,
          color: Colors.AzulMediline,
        }}
      >
        404
      </Typography>

      <Typography sx={{ fontSize: "1.25rem", fontWeight: 700, color: Colors.AzulMediline }}>
        Página no encontrada
      </Typography>

      <Typography sx={{ fontSize: "0.95rem", color: Colors.GrisMedio, maxWidth: "420px" }}>
        La dirección que ingresaste no existe o fue movida. Verificá la URL o volvé al inicio.
      </Typography>

      <Button
        variant="contained"
        onClick={() => navigate("/")}
        sx={{
          marginTop: "0.5rem",
          background: `linear-gradient(195deg, ${Colors.AzulMediline}, ${Colors.AzulMedilineClaro})`,
          borderRadius: "25px",
          textTransform: "capitalize",
          padding: "0.5rem 2rem",
          boxShadow: "0 8px 24px rgba(0, 44, 84, 0.25)",
          "&:hover": {
            background: `linear-gradient(195deg, ${Colors.AzulMediline}, ${Colors.AzulMedilineClaro})`,
            filter: "brightness(1.1)",
          },
        }}
      >
        Volver al inicio
      </Button>
    </Box>
  );
};

export default NotFound;
